import PropTypes from 'prop-types';
import { Label } from './ui/label';
import { cn } from '../lib/utils';

const FormField = ({
  label,
  htmlFor,
  hint,
  optional,
  required,
  className,
  children,
}) => {
  const isOptional = optional || (hint && hint.toLowerCase() === 'optional');
  const actualHint = hint && hint.toLowerCase() !== 'optional' ? hint : null;

  return (
    <div className={cn('space-y-1.5', className)}>
      <div className="flex items-center justify-between">
        <Label htmlFor={htmlFor} className="text-sm font-semibold text-slate-700">
          {label}
          {required && <span className="ml-1 text-red-500" aria-hidden="true">*</span>}
        </Label>
        {isOptional && (
          <span className="text-xs font-medium text-slate-400">Optional</span>
        )}
      </div>
      {children}
      {actualHint && (
        <p className="text-xs leading-relaxed text-slate-500">{actualHint}</p>
      )}
    </div>
  );
};

FormField.propTypes = {
  label: PropTypes.string.isRequired,
  htmlFor: PropTypes.string,
  hint: PropTypes.string,
  optional: PropTypes.bool,
  required: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default FormField;
